// Pagine pubbliche dei tool (api/public/tools). Usato dalle pagine del sito: solo fetch,
// niente Firebase né axios, così la parte pubblica resta leggera.
import { API_CONFIG } from '../config/api.config';

export interface PublicToolSummary {
    code: string;
    name: string;
    summary?: string | null;
    toolType: string;
    hasIcon: boolean;
    updatedAt?: string | null;
}

export interface PublicToolPage {
    code: string;
    name: string;
    description?: string | null;
    toolType: string;
    hasIcon: boolean;
    language: string;
    content: string;
    updatedAt?: string | null;
    related: PublicToolSummary[];
}

/** Un tool o una pagina che non esiste (404): la pagina mostra "non trovata", non un errore. */
export class PublicPageNotFound extends Error {}

async function getJson<T>(path: string, signal?: AbortSignal): Promise<T> {
    const response = await fetch(`${API_CONFIG.BASE_URL}${path}`, { signal, headers: { Accept: 'application/json' } });
    if (response.status === 404) throw new PublicPageNotFound();
    if (!response.ok) throw new Error(`Richiesta non riuscita (${response.status})`);
    return response.json() as Promise<T>;
}

export const getPublicTools = (signal?: AbortSignal) =>
    getJson<PublicToolSummary[]>('/api/public/tools?lang=it', signal);

export const getPublicToolPage = (code: string, signal?: AbortSignal) =>
    getJson<PublicToolPage>(`/api/public/tools/${encodeURIComponent(code)}?lang=it`, signal);

/** Icona del tool (ruolo "tab"), servita senza login. */
export const toolIconUrl = (code: string) => `${API_CONFIG.BASE_URL}/api/Tools/image/${encodeURIComponent(code)}/tab`;

/** Nomi italiani dei tipi di tool, come nel catalogo del workspace. */
export const TOOL_TYPE_LABELS: Record<string, string> = {
    Development: 'Sviluppo',
    Data: 'Dati',
    Customization: 'Personalizzazione',
    Administration: 'Amministrazione',
    Analytics: 'Analytics',
    Diagnostics: 'Diagnostica',
    Trace: 'Diagnostica',
};
